<template>
  <div class="shadow-fixed show">
    <div class="mask"></div>
    <div class="visaflow-box">
      <div class="visaflow-small-close" @click="closeDUpdate"></div>
      <div class="visaflow-inner">
        <p>请上传图片</p>
        <d-upload @getPicArr="getPicArr($event)" :src="src"></d-upload>
      </div>
      <div class="visaflow-btn" @click="update">
        <span>确定</span>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/d-visaflow/d-visaflow.scss"

import dUpload from "./d-upload"

import { CreateVisaflow, UpdateVisaflow } from '../../../../../api/index'

export default {
  name: 'd-visaflow',
  data() {
    return {
      picArr: [],
      src: require('../../../../../html/components/d-visaflow/images/upload.png'),
    }
  },
  components: {
    dUpload
  },
  props:{
    id:{
      type:Number,
      required:false
    },
    FlowStatus:{
      type:Number,
      required:false
    }
  },
  methods: {
    getPicArr(data) {
      this.picArr = data;
    },
    closeDUpdate() {
      this.$emit('closeDUpdate')
    },
    async update() {
      if (this.picArr.length == 0) {
        this.$layer.alert('图片不能为空');
      } else {
        let res = await UpdateVisaflow({
          id: this.id,
          FlowStatus: this.FlowStatus + 1,
          ImgPaths: this.picArr.join()
        })
        // console.log(res);
        if(res.Type == "Success"){
          this.$layer.alert('修改成功',(layerid)=>{
            this.$layer.close(layerid);
            this.$emit("closeDUpdate")
          })
        }
      }
    }
  },
  mounted() {
  }
}
</script>